import { FC, useState, useCallback } from 'react'
import { FocusinHandler } from 'handlers/FocusinHandler/FocusinHandler'
import { AccordionTab } from 'components/atoms/accordion/AccordionTab/AccordionTab'

type AccordionTabFocusinPresetProps = {
  label: string
  initialOpen?: boolean
  onFocus?: () => void
  onBlur?: () => void
}
export const AccordionTabFocusinPreset: FC<AccordionTabFocusinPresetProps> = (props) => {
  const { children, initialOpen, label } = props

  const [isOpen, setIsOpen] = useState(!!initialOpen)

  const handleClick = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  const handleFocus = useCallback(() => {
    setIsOpen(true)
  }, [])

  return (
    <FocusinHandler onFocus={ handleFocus }>
      <AccordionTab isOpen={ isOpen } onClick={ handleClick } label={ label }>
        { children }
      </AccordionTab>
    </FocusinHandler>
  )
}
